<template>
  <div>
    <Head title="Alle Prüfungen"/>
    <h1 class="h1">Alle Prüfungen</h1>
    <div class="flex items-center justify-between mb-6">
<!--      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">-->
<!--        <label class="block text-gray-700">Trashed:</label>-->
<!--        <select v-model="form.trashed" class="form-select mt-1 w-full">-->
<!--          <option :value="null"/>-->
<!--          <option value="with">With Trashed</option>-->
<!--          <option value="only">Only Trashed</option>-->
<!--        </select>-->
<!--      </search-filter>-->
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 lg:grid-cols-4 gap-4">
      <exam-item
          v-for="exam in exams.data"
          :key="exam.id"
          :exam="exam"
      />
    </div>

    <div v-if="exams.data.length === 0">
      Derzeit stehen keine Prüfungen zur Verfügung
    </div>

    <pagination class="mt-6" :links="exams.links"/>

  </div>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Pagination,
    SearchFilter,
  },

  layout: Layout,

  props: {
    exams: Array,
  },

  mounted() {
    console.log(this.exams)
  },

  data() {
    return {
      form: {
        // search: this.filters.search,
        // trashed: this.filters.trashed,
      },
    }
  },

  methods: {
    reset() {
      // this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
